<template>
<div>
    <div class="row no-gutters ml-3 mr-3" v-if="(userPrivacy == 'PRIVATE' && (getuserid != loginuserid)) || (!userCountryId && workExperience.length < 1 && educationList.length<1 && userKnowledgeList.length<1 && userTechnologyList.length<1)">
        <div class="col-12 mb-3">
            <div class="card" >
                <div class="mt-3 mb-3 ml-3 mx-auto">
                    <span class="proximanova-bold fontsize16 black60 mx-auto">No Details Found</span>
                </div>
            </div>
        </div>
    </div>
    <div class="pb-5" v-if="userPrivacy != 'PRIVATE' || (getuserid == loginuserid)">
        <div class="row no-gutters ml-3 mr-3" v-if="(getuserid == loginuserid) || (currentRoute == 'welcome')">
            <div class="col-12 mb-3">
                <div class="shadow card">
                    <div class="row no-gutters">
                        <div class="col d-flex">
                            <div class="mt-3 mb-3 ml-4 mr-auto">
                                <label class="proximanova-bold fontsize16 black60 label-bottom">Contact Details</label>
                            </div>
                            <span class="d-flex" v-if="(getuserid == loginuserid) || (currentRoute == 'welcome')">
                            <div class="justify-content-end mt-3 mb-3 pl-1 profdetails" v-if="!primaryphoneno">
                                <img src="../../assets/NotStarted.svg" alt="notstarted" class="img-fluid mr-1" />
                                <label class="mr-3 fontsize12 proximanova black60">Not Started</label>
                            </div>
                            <div class="justify-content-end mt-3 mr-3 mb-3 pl-1 profdetails" v-if="!primaryphoneno" @click="routetopage('contact_details')">
                                <img src="../../assets/Add.svg" alt="notstarted" class="img-fluid mr-1" />
                                <label class="mr-3 fontsize12 proximanova-semibold black">Add</label>
                            </div>
                            <div class="justify-content-end mt-3 mb-3 pl-1 mr-3 profdetails" v-if="primaryphoneno">
                                <div @click="routetopage('contact_details')">
                                <img src="../../assets/Edit.svg" alt="notstarted" class="img-fluid mr-1" />
                                <label class="mr-3 fontsize12 proximanova-semibold black">Edit</label>
                                </div>
                            </div>
                            </span>
                        </div>
                    </div>
                    <div class="col pb-4 pl-4" v-if="primaryphoneno">
                        <div class="row no-gutters pb-3">
                            <div class="col">
                                <div v-if="email">
                                    <span class="proximanova fontsize14 black60">Email Address</span> <br>
                                    <span class="proximanova fontsize14">{{email}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="row no-gutters">
                            <div class="col">
                                <div v-if="primaryphoneno">
                                <span class="proximanova fontsize14 black60">Primary Mobile</span> <br>
                                <span class="proximanova fontsize14">{{primaryphoneno}}</span>
                                </div>
                            </div>
                            <div class="col ">
                                <div v-if="alternatePhoneNumber">
                                <span class="proximanova fontsize14 black60">Alternative Mobile</span> <br>
                                <span class="proximanova fontsize14">{{alternatePhoneNumber}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row no-gutters ml-3 mr-3" v-if="(currentRoute != 'selectedloginviewuserprofile' && getuserid == loginuserid) || workExperience.length > 0">
            <div class="col-12 mb-3">
                <div class="shadow card">
                    <div class="row no-gutters">
                        <div class="col d-flex">
                            <div class="mt-3 mb-3 ml-3 mr-auto">
                                <label class="proximanova-bold fontsize16 black60 label-bottom">Work Experience</label>
                            </div>
                            <span class="d-flex" v-if="(getuserid == loginuserid) || (currentRoute == 'welcome')">
                            <div class="justify-content-end mt-3 mb-3 pl-1 profdetails" v-if="workExperience.length<1">
                                <img src="../../assets/NotStarted.svg" alt="notstarted" class="img-fluid mr-1" />
                                <label class="mr-3  fontsize12 proximanova black60">Not Started</label>
                            </div>
                            <div class="justify-content-end mt-3 mr-3 mb-3 pl-1 profdetails" v-if="workExperience.length<1" @click="routetopage('work_exp')">
                                <img src="../../assets/Add.svg" alt="add" class="img-fluid mr-1" />
                                <label class="mr-3 fontsize12 proximanova-semibold black">Add</label>
                            </div>
                            <div class="justify-content-end mt-3 mr-3 mb-3 pl-1 profdetails" v-if="workExperience.length>0" @click="routetopage('work_exp')">
                                <img src="../../assets/Add.svg" alt="add" class="img-fluid mr-1" />
                                <label class="mr-3 fontsize12 proximanova-semibold black">Add</label>
                            </div>
                            <div class="justify-content-end mt-3 mb-3 pl-1 mr-3 profdetails" v-if="workExperience.length>0">
                                <div @click="routetopage('work_exp')">
                                <img src="../../assets/Edit.svg" alt="edit" class="img-fluid mr-1" />
                                <label class="mr-3 fontsize12 proximanova-semibold black">Edit</label>
                                </div>
                            </div>
                            </span>
                        </div>
                    </div>
                    <div v-if="workExperience.length > 0" class="pb-3">
                        <div v-for="(exp, index) in workExperience" :key="index">
                            <div class="col d-flex mb-4">
                                <div class="">
                                    <img src="../../assets/Company_Icon.svg" alt="companylogo" class="img-fluid p-1 rounded-circle border compIcon">
                                </div>
                                <div class="col-10">
                                    <div class="d-flex fontsize14 proximanova-semibold black text-capitalize my-suto">
                                        {{exp.companyDetails.companyName}}
                                        <!-- <div>
                                            <div class="d-flex pointer borderblack60 borderradius20 ml-2 pl-2 pr-2" v-if="exp.currentWorkingFlag == 'Y' && ( !exp.verification_flag || exp.verification_flag == 'NOT VERIFIED' || exp.verification_flag == 'REJECTED')" @click="displayWorkEmailVerificationModal(index)">
                                                <img src="../../assets/verify_red.svg" class="my-auto" alt="verify" width="18px" title="Verify your identity" > 
                                                <span class="fontsize12 verify proximanova mt-1 pointer d-block d-md-none ml-1"> Verify</span>
                                                <span class="fontsize12 verify proximanova mt-1 pointer d-none d-md-block ml-1"> Get Verified</span>
                                            </div>
                                            <div class="d-flex pointer">
                                                <img src="../../assets/verify_orange.svg" class="my-auto ml-1" alt="verify" width="20px" title="Verification pending" v-if="exp.verification_flag && exp.verification_flag == 'REVIEW'"> 
                                                <span class="fontsize12 verifycolor1 proximanova my-auto pointer d-none d-md-block ml-1" v-if="exp.verification_flag && exp.verification_flag == 'REVIEW'"> Verification Pending</span>
                                                <img src="../../assets/verify_blue.svg" class="my-auto ml-1" alt="verify" width="20px" title="Verified" v-if="exp.verification_flag && exp.verification_flag == 'VERIFIED'"> 
                                            </div>
                                        </div> -->
                                    </div>
                                    <div class="fontsize14 black80 proximanova text-capitalize">
                                        {{exp.userRoles.roleName}} - {{exp.employeementTypeString}}
                                    </div>
                                    <div class="d-flex expDetails proximanova-semibold fontsize12 black30 ">
                                        <div v-if="exp.startDate">{{exp.startDate | moment("MMM YYYY") }}</div> <span class="pl-lg-2 pr-lg-2 pr-1 pl-1"> - </span>
                                        <div v-if="exp.endDate">{{exp.endDate | moment("MMM YYYY")}}</div>
                                        <div v-if="exp.currentWorkingFlag == 'Y'">Present</div> <span class="pr-lg-2 pr-1"> , </span>
                                        <div v-if="exp.totalExperience && exp.currentWorkingFlag == 'N'">{{exp.totalExperience}}</div>
                                        <div v-else>{{new Date(exp.startDate) | moment("from", "now", true)}}</div>
                                    </div>
                                    <div class="proximanova-semibold fontsize12 black30  text-capitalize d-flex">
                                        <span v-if="exp.city" class="mr-1">{{exp.city.cityName}} ,</span><span v-if="exp.country">{{exp.country.countryName}}</span>
                                    </div>
                                    <div v-if="exp.description" class="d-flex flex-nowrap mt-2">
                                        <div class="fontsize14 black80 proximanova ">
                                            <span :id="'expdescript'+index">{{exp.description1}} </span>
                                            <span class="proximanova fontsize14 blue pointer readmorelink" :id="'readmore'+index" v-if="exp.description2.length>0" @click="readMoreExp">...readmore</span>
                                            <span class="proximanova fontsize14 blue pointer readlesslink" :id="'readless'+index" @click="readLessExp">...readless</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row no-gutters ml-3 mr-3" v-if="(currentRoute != 'selectedloginviewuserprofile' && getuserid == loginuserid)  || educationList.length > 0">
            <div class="col-12 mb-3">
                <div class="shadow card">
                    <div class="row no-gutters">
                        <div class="col d-flex">
                            <div class="mt-3 mb-3 ml-3 mr-auto">
                                <label class="proximanova-bold fontsize16 black60 label-bottom">Education/Certifications</label>
                            </div>
                            <span class="d-flex" v-if="(getuserid == loginuserid) || (currentRoute == 'welcome')">
                            <div class="justify-content-end mt-3 mb-3 pl-1 profdetails" v-if="educationList.length < 1">
                                <img src="../../assets/NotStarted.svg" alt="notstarted" class="img-fluid mr-1" />
                                <label class="mr-3 fontsize12 proximanova black60 black">Not Started</label>
                            </div>
                            <div class="justify-content-end mt-3 mr-3 mb-3 pl-1 profdetails" v-if="educationList.length < 1" @click="routetopage('education')">
                                <img src="../../assets/Add.svg" alt="add" class="img-fluid mr-1" />
                                <label class="mr-3 fontsize12 proximanova-semibold black">Add</label>
                            </div>
                            <div class="justify-content-end mt-3 mr-3 mb-3 pl-1 profdetails" v-if="educationList.length > 0" @click="routetopage('education')">
                                <img src="../../assets/Add.svg" alt="add" class="img-fluid mr-1" />
                                <label class="mr-3 fontsize12 proximanova-semibold black">Add</label>
                            </div>
                            <div class="justify-content-end mt-3 mb-3 pl-1 mr-3 profdetails" v-if="educationList.length > 0">
                                <div @click="routetopage('education')">
                                <img src="../../assets/Edit.svg" alt="edit" class="img-fluid mr-1" />
                                <label class="mr-3 fontsize12 proximanova-semibold black">Edit</label>
                                </div>
                            </div>
                            </span>
                        </div>
                    </div>
                    <div v-if="educationList.length > 0" class="pb-3">
                        <div v-for="(edu, index) in educationList" :key="index">
                            <div class="col d-flex mb-4">
                                <div class="">
                                <img src="../../assets/Company_Icon.svg" alt="companylogo" class="img-fluid p-1 rounded-circle border compIcon">
                                </div>
                                <div class="col-10">
                                <div class="fontsize14 proximanova-semibold black text-capitalize">
                                    {{edu.instituteDetails.instituteName}}
                                </div>
                                <div class="fontsize14 black80 proximanova">
                                    {{edu.fieldOfStudy.fieldName}}
                                </div>
                                <div class="d-flex educationDetails proximanova-semibold fontsize12 black30 ">
                                    <div v-if="edu.fromDate">{{edu.fromDate | moment("MMM YYYY") }}</div> <span class="pl-lg-2 pr-lg-2 pl-1 pr-1"> - </span>
                                    <div v-if="edu.toDate">{{edu.toDate | moment("MMM YYYY")}}</div>
                                    <div v-if="edu.currentStudyFlag == 'Y'">Present</div> <span class="pr-lg-2 pr-1"> , </span>
                                    <div v-if="edu.educationDuration">{{edu.educationDuration}}</div>
                                    <div v-else>{{new Date(edu.fromDate) | moment("from", "now", true)}}</div>
                                </div>
                                <div class="proximanova fontsize14 black80  text-capitalize d-flex">
                                    <span v-if="edu.city" class="mr-1">{{edu.city.cityName}} , </span> <span v-if="edu.country">{{edu.country.countryName}}</span>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row no-gutters no-gutters ml-3 mr-3" v-if="currentRoute != 'selectedloginviewuserprofile' && (getuserid == loginuserid  || userCountryId || userStateId || userZipcode)">
            <div class="col-12 mb-3">
                <div class="shadow card">
                    <div class="row no-gutters">
                        <div class="col d-flex">
                            <div class="mt-3 mb-3 ml-3 mr-auto">
                                <label class="proximanova-bold fontsize16 black60 label-bottom">Location</label>
                            </div>
                            <span class="d-flex" v-if="(getuserid == loginuserid) || (currentRoute == 'welcome')">
                            <div class="justify-content-end mt-3 mb-3 pl-1 profdetails" v-if="!userZipcode && !userCountry && !userState">
                                <img src="../../assets/NotStarted.svg" alt="notstarted" class="img-fluid mr-1" />
                                <label class="mr-3 fontsize12 proximanova black60 black">Not Started</label>
                            </div>
                            <div class="justify-content-end mt-3 mr-3 mb-3 pl-1 profdetails" v-if="!userZipcode" @click="routetopage('current_location')">
                                <img src="../../assets/Add.svg" alt="add" class="img-fluid mr-1" />
                                <label class="mr-3 fontsize12 proximanova-semibold black">Add</label>
                            </div>
                            <div class="justify-content-end mt-3 mb-3 pl-1 mr-3 profdetails" v-if="userCountry || userState || userZipcode">
                                <div @click="routetopage('current_location')">
                                <img src="../../assets/Edit.svg" alt="edit" class="img-fluid mr-1" />
                                <label class="mr-3 fontsize12 proximanova-semibold black">Edit</label>
                                </div>
                            </div>
                            </span>
                        </div>
                    </div>
                    <div class="pb-3" v-if="userCountryId || userStateId || userZipcode">
                        <div class="col d-flex mb-3">
                            <div class="">
                                <img src="../../assets/Company_Icon.svg" alt="companylogo" class="img-fluid p-1 rounded-circle border compIcon">
                            </div>
                            <div class="col-10">
                                <div class="fontsize14 proximanova-semibold black text-capitalize" v-if="userCountry">{{userCountry.countryName}}</div>
                                <div class="fontsize14 black80 proximanova" v-if="userState">{{userState.stateName}}</div>
                                <div class="proximanova-semibold fontsize12 black30 ">
                                    <span v-if="userCity">{{userCity.cityName}}</span>
                                    <span v-if="userZipcode">, Pincode : {{userZipcode}}</span>
                                </div>
                                <div class="fontsize14 black80 proximanova mt-2 d-flex justify-content-between" v-if="(getuserid == loginuserid)">
                                    <div v-if="workAuthorizationString">Work Authorization : {{workAuthorizationString}}</div>
                                <!-- <div>Prefered Location</div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row no-gutters ml-3 mr-3" v-if="(currentRoute != 'selectedloginviewuserprofile' && getuserid == loginuserid)  || userKnowledgeList.length > 0|| userTechnologyList.length > 0">
            <div class="col-12 mb-3">
                <div class="shadow card " :class="{'pb-4':(userKnowledgeList.length>0 || userTechnologyList.length>0)}">
                    <div class="row no-gutters">
                        <div class="col d-flex">
                            <div class="mt-3 mb-3 ml-3 mr-auto">
                                <label class="proximanova-bold fontsize16 black60 label-bottom">Skills</label>
                            </div>
                            <span v-if="(getuserid == loginuserid) || (currentRoute == 'welcome')">
                            <div class="justify-content-end mt-3 mb-3 pl-1 mr-3 profdetails" v-if="userKnowledgeList.length>0 || userTechnologyList.length>0">
                                <div @click="routetopage('skills')">
                                <img src="../../assets/Edit.svg" alt="edit" class="img-fluid mr-1" />
                                <label class="mr-3 fontsize12 proximanova-semibold black">Edit</label>
                                </div>
                            </div>
                            <div v-else class="d-flex">
                                <div class="justify-content-end mt-3 mb-3 pl-1 profdetails">
                                <img src="../../assets/NotStarted.svg" alt="notstarted" class="img-fluid mr-1" />

                                <label class="mr-3 fontsize12 proximanova black60 black">Not Started</label>
                                </div>
                                <div class="justify-content-end mt-3 mb-3 pl-1  mr-3 profdetails" @click="routetopage('skills')">
                                <img src="../../assets/Add.svg" alt="add" class="img-fluid mr-1" />
                                <label class="mr-3 fontsize12 proximanova-semibold black">Add</label>
                                </div>
                            </div>
                            </span>
                        </div>
                    </div>
                    <div v-if="userKnowledgeList.length > 0" class="col ml-2">
                        <span class="proximanova fontsize14 black80 mb-3">Knowledge In</span>
                        <div class="d-flex flex-wrap">
                          <div v-for="(skill, index) in userKnowledgeList" :key="index" >
                            <div class="pl-2 pr-4 pt-1 pb-1 mr-2 mb-1 knowledgeItem d-flex mt-1 black60 proximanova fontsize12">
                              {{skill.knowledgeDetails.knowledgeIn}}
                            </div>
                          </div>
                        </div>
                    </div>
                    <div v-if="userTechnologyList.length > 0" class="col mt-2 pb-4 ml-2">
                        <span class="proximanova fontsize14 black80 mb-2">Tools</span>
                        <div class="d-flex flex-wrap">
                          <div v-for="(technology, index) in userTechnologyList" :key="index" >
                            <div class="pl-2 pr-4 pt-1 pb-1 mr-2 knowledgeItem d-flex mt-1 black60 proximanova fontsize12">
                              {{technology.technologyDetails.technologyName}}
                            </div>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <WorkexpEmailVerification v-if="openWorkEmailVerificationModal" :selectedWorkExperienceObj="selectedWorkExperienceObj" @closeWorkEmailVerificationmodal= "closeWorkEmailVerificationmodal"/>
    </div>
</template>
<script>
import $ from "jquery";
import router from '../../router'
import sessionUtils from '@/js/session-util.js'
import commonUtils from "../../js/common-utils";
import WorkexpEmailVerification from "../../components/WorkexpEmailVerification.vue";
export default {
    props : ['userProfileDetails'],
    components : {
        WorkexpEmailVerification
    },
    data() {
        return{
            currentRoute : null,
            loginuserid : sessionUtils.getUserId(),
            // loginuserid : 5,
            loginuserprofileid : sessionUtils.getUserProfileId(),
            getuserid : null,
            profileId : null,
            email : '',
            primaryphoneno: "",
            alternatePhoneNumber : '',
            workExperience: [],
            educationList : [],
            userStateId : null,
            userCountryId : null,
            userCityId : null,
            userState : {},
            userCity : {},
            userCountry : {},
            userZipcode : '',
            userWorkAuthorization : '',
            workAuthorizationString : '',
            userKnowledgeList : [],
            userTechnologyList : [],
            userPrivacy : 'PUBLIC',
            // workexperience verification section
            openWorkEmailVerificationModal : false,
            selectedWorkExperienceObj : false,
        }
    },
    mounted() {
        console.log("user profile data in profile details tab : " , this.userProfileDetails)
        var size = Object.keys(this.userProfileDetails).length;
        if(this.userProfileDetails && size > 0){
            this.setData()
        }
        this.currentRoute = this.$route.name;
    },
    methods : {
        setData : function() {
            this.profileId = this.userProfileDetails.profileId;
            this.getuserid = this.userProfileDetails.userId;
                //contact info
            this.email = this.userProfileDetails.email;
            this.primaryphoneno = this.userProfileDetails.primaryPhoneNumber;
            this.alternatePhoneNumber = this.userProfileDetails.alternatePhoneNumber;
            //experience
            this.workExperience = this.userProfileDetails.workExperience
            //education
            this.educationList = this.userProfileDetails.userEducation
            //location
            this.userCityId = this.userProfileDetails.cityId;
            this.userStateId = this.userProfileDetails.stateId;
            this.userCountryId = this.userProfileDetails.countryId;
            this.userCountry = this.userProfileDetails.country;
            this.userState = this.userProfileDetails.state;
            this.userCity = this.userProfileDetails.city;
            this.userZipcode = commonUtils.setPincode(this.userProfileDetails.zipCode)
            this.userWorkAuthorization = this.userProfileDetails.workAuthorization;
            this.workAuthorizationString = this.userProfileDetails.workAuthorizationString;
            //skills
            this.userKnowledgeList = this.userProfileDetails.userKnowledge;
            this.userTechnologyList = this.userProfileDetails.userTechnology;
            //privacy
            if(this.userProfileDetails.privacy){
                this.userPrivacy = this.userProfileDetails.privacy
            }
        },
        routetopage : function(elementname) {
            console.log("element name : ", elementname)
            if(this.profileId !== null & this.profileId !== undefined) {
                // sessionStorage.setItem('activeElement', elementname)
                this.$session.set("activeElement", elementname)
                router.push({
                name : 'editprofile'
                })
            }else{
                this.$session.set('activeElement', 'basic_info')
                router.push({
                name : 'createprofile'
                })
            }
        },
        //readmore experience description
        readMoreExp  :function(event) {
            let index = event.target.id.substr(8)
            this.workExperience[index].description1 = this.workExperience[index].description1.concat(this.workExperience[index].description2)
            let relessId = "readless"+index
            document.getElementById(relessId).style.display = 'inline-block'
            document.getElementById(event.target.id).style.display = 'none'
            document.getElementById('expdescript'+index).innerHTML = this.workExperience[index].description1;
        },
        //readless experience description
        readLessExp : function(event) {
            let index = event.target.id.substr(8)
            this.workExperience[index].description1 = this.workExperience[index].description1.substr(0, 196)
            let remoreId = "readmore"+index
            document.getElementById(remoreId).style.display = 'inline-block'
            document.getElementById(event.target.id).style.display = 'none'
            document.getElementById('expdescript'+index).innerHTML = this.workExperience[index].description1;
        },
        displayWorkEmailVerificationModal(index) {
            this.selectedWorkExperienceObj = this.workExperience[index]
            this.openWorkEmailVerificationModal = true;
        },
        closeWorkEmailVerificationmodal(status){
            console.log("work exp status after close : ", status)
            if(status == 'SUCCESS'){
                this.selectedWorkExperienceObj.verification_flag = 'REVIEW';
            }
            this.openWorkEmailVerificationModal = false;
        }
    }
}
</script>
<style scoped>
.readlesslink {
  display: none;
}
.card {
  border: 1px solid #dddfe5;
  border-radius: 10px;
  background-color: #ffffff;
}
.profdetails {
  cursor: pointer;
  transition : ease-out 0.3s;
  POSITION : relative;
	z-index : 1;
}
.profdetails::before {
	transition : 0.5s all ease;
	position : absolute;
	top : 0;
	left : 30%;
	right : 30%;
	bottom : 0;
	opacity : 0;
	content : "";
  border-radius: 20px;
	background-color :  rgba(29, 27, 27, 0.1);
}
.profdetails:hover:before {
	transition : 0.5s all ease;
	left : 0;
	right : 0;
	opacity : 1;
	z-index : -1
}
.compIcon {
  width: 40px;
}
.expDetails {
  white-space: nowrap;
}
.educationDetails {
  white-space: nowrap;
}
.label-bottom {
  margin-bottom: 0.25rem !important;
  margin-top: 0.25rem !important;
}
.knowledgeItem {
  border-radius: 5px;
  cursor: pointer;
  background-color: rgba(231,233,240,.6);
}
</style>